


































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { CommonAuditStatus } from '@/api/models';
import userModel from '@/store/modules/user';
import UserModule from '@/store/modules/user';
class Audit {
  orgAuditStatus?: CommonAuditStatus | undefined /** 干教处审核状态 */;
  auditStatus?: CommonAuditStatus | undefined /** 培训班名称 */;
  className?: string | undefined /** 请假开始时间 */;
  startDate?: string | undefined /** 请假截止时间 */;
  endDate?: string | undefined;
  pageIndex: number | undefined = 1;
  pageSize: number | undefined = 10;
}

@Component
export default class LeaveApproval extends Vue {
  loading: boolean = false;
  finished: boolean = false;
  query: Audit = new Audit();
  auditData: any = [];
  currentData: any = [];

  mounted() {
    this.onLoad();
  }

  get TimeSlot() {
    return models.TimeSlot;
  }

  get CommonAuditStatus() {
    return models.CommonAuditStatus;
  }

  get userType() {
    return parseInt(UserModule.info.type);
  }

  get AdminStateTag() {
    let color = null;
    let text = null;
    return (state: any) => {
      if (state == this.CommonAuditStatus.待审核) {
        color = '#ff976a';
        text = '待审核';
      }
      if (state == this.CommonAuditStatus.已通过) {
        color = '#07c160';
        text = '已通过';
      }
      if (state == this.CommonAuditStatus.未通过) {
        color = '#ff0000';
        text = '未通过';
      }
      return { color, text };
    };
  }

  get StateTag() {
    let color = null;
    let text = null;
    return (state: any) => {
      if (state.orgAuditStatus == this.CommonAuditStatus.待审核) {
        color = '#ff976a';
        text = '待审核';
      }
      if (
        (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == null) ||
        state.auditStatus == this.CommonAuditStatus.已通过
      ) {
        color = '#07c160';
        text = '已通过';
      }
      if (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == this.CommonAuditStatus.待审核) {
        color = '#1989fa';
        text = '干教处待审核';
      }
      if (
        state.orgAuditStatus == this.CommonAuditStatus.未通过 ||
        (state.orgAuditStatus == this.CommonAuditStatus.已通过 && state.auditStatus == this.CommonAuditStatus.未通过)
      ) {
        color = '#ff0000';
        text = '未通过';
      }
      return { color, text };
    };
  }

  toDetail(item, type) {
    /** type 0:只读；1:可编辑 */
    this.$router.push({ name: 'LeaveAudit', query: { auditInfo: JSON.stringify(item), type: type } });
  }

  /**请假信息修改 */
  toEditForm(item) {
    this.$router.push({ name: 'LeaveEdit', query: { leaveInfo: JSON.stringify(item), className: item.className } });
    console.log('%c [ item ]-169', 'font-size:13px; background:pink; color:#bf2c9f;', item);
  }

  onLoad() {
    this.getAuditData();
  }

  async getAuditData() {
    try {
      this.loading = true;

      const { data } = await api.Leaves.findMyAuditLeaves_GET(this.query);
      this.query.pageIndex++;
      this.currentData = data.result.items;
      this.auditData = this.auditData.concat(this.currentData);
      if (this.auditData.length == data.result.totalItemCount || data.result.items?.length == 0) this.finished = true;
    } catch (error) {
      console.log(error.toString());
    } finally {
      this.loading = false;
    }
  }
}
